<div [ngSwitch]="state">
    <div *ngSwitchCase="eInvitation.Account">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{endpoints.login}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Ksuite">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{endpoints.login}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.KsuiteMailbox">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{logoutWebmail()}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Drive">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{endpoints.login}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Webmail">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{endpoints.login}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Transfer">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{endpoints.login}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
    <div *ngSwitchCase="eInvitation.Password">
        <h1>{{'L\'invitation ne concerne pas ce compte' | transloco}}</h1>
        <p>{{'Vous n\'etes pas connecte sur le compte infomaniak qui a ete invite.' | transloco}}</p>
        <p class="margin-bottom-50">
            {{'Veuillez vous connecter sur le bon compte, celui mentionne dans le mail d\'invitation.' | transloco}}</p>
        <div class="xs-align-center">
            <a class="mat-elevation-z"
               color="primary"
               href="{{endpoints.login}}"
               mat-raised-button>
                {{ 'Changer de compte' | transloco }}
            </a>
        </div>
    </div>
</div>
